import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {uniq} from 'lodash';
import {HttpStatusCodes} from '../../util/uiconstants';

export function validationCountsReducer(state = initialstate.validations, action) {
	let documentId;
	switch (action.type) {
		case types.UNLOAD_VALIDATION_COUNTS: {
			documentId = action.documentId;

			return {
				...state,
				[documentId]: undefined
			};
		}
		case types.GET_VALIDATIONCOUNTS: {
			let result = {
				...state
			};

			if (action.responseObj.status === HttpStatusCodes.Ok) {
				if (!Array.isArray(action.response)) return result;

				let documentIds = action.documentIds;
				let embeddedDocumentIds = action.embeddedDocumentIds;

				const docIds = uniq(action.response.map((v) => v.documentId));

				if (embeddedDocumentIds) {
					for (let id of docIds) {
						let validations = action.response.filter((v) => v.documentId === id);
						result[id] = validations;
					}

					const docsWithNoValidations = embeddedDocumentIds.filter((id) => !docIds.includes(id));

					for (const id of docsWithNoValidations) {
						delete result[id];
					}
				} else {
					for (let id of documentIds) {
						let validations = action.response.filter((v) => v.documentId === id);

						// Always update validations
						result[id] = validations;
					}
				}
			}

			return result;
		}
		case types.REFRESH_VALIDATION_COUNTS:
			return null;
		default:
			return state;
	}
}

export function validationDetailsReducer(state = initialstate.validationdetails, action) {
	switch (action.type) {
		case types.UNLOAD_VALIDATION_DETAILS:
			return {};
		case types.GET_VALIDATIONDETAILS:
			return action.response || state;
		default:
			return state;
	}
}

export function withoutApprovalvalidationCountsReducer(state = initialstate.withoutapprovalvalidations, action) {
	switch (action.type) {
		case types.GET_WITHOUT_APPROVAL_VALIDATION_COUNTS: {
			let result = {};
			let documentIds = action.documentIds;

			for (let id of documentIds) {
				let validations = action.response.filter((v) => v.documentId === id);

				// Always update validations
				result[id] = validations;
			}

			return {
				...state,
				...result
			};
		}
		default:
			return state;
	}
}

export function validationFilterValueReducer(state = initialState.leftPanelValidationFilterValue, action) {
	switch (action.type) {
		case types.SET_VALIDATION_FILTER_VALUE:
			return action.leftPanelValidationFilterValue;
		default:
			return state;
	}
}

export function auditPlanSummaryValidationsReducer(state = initialstate.auditPlanSummaryValidations, action) {
	switch (action.type) {
		case types.GET_AUDIT_PLAN_SUMMARY_VALIDATIONS: {
			if (action.responseObj?.status === HttpStatusCodes.Ok && Array.isArray(action.response)) {
				return action.response;
			}
			return state;
		}
		case types.CLEAR_AUDIT_PLAN_SUMMARY_VALIDATIONS: {
			return [];
		}
		default:
			return state;
	}
}
